import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

const FaqItemSchema = buildEntrySchemaFor('faqItem', {
  fields: z.lazy(() =>
    z.object({
      question: z.string(),
      answer: RichTextSchema,
    }),
  ),
})

export const FaqGroupSchema = buildEntrySchemaFor('faqGroup', {
  fields: z.lazy(() =>
    z.object({
      heading: z.string().optional(),
      faqs: z.array(FaqItemSchema),
    }),
  ),
})

export type FaqGroup = z.infer<typeof FaqGroupSchema>
